<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex md12 v-if="this.funcionario.item != null">
            <strong>Nro de item:</strong> {{ this.funcionario.item }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.padres_unidad != null">
            <strong>Dependencia:</strong> {{ this.funcionario.padres_unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.unidad != null">
            <strong>Nombre unidad:</strong> {{ this.funcionario.unidad }}
          </v-flex>

          <v-flex md12 v-if="this.funcionario.cargo != null">
            <strong>Cargo:</strong> {{ this.funcionario.cargo }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.puesto != null">
            <strong>Puesto:</strong> {{ this.funcionario.puesto }}
          </v-flex>

          <v-flex md6 v-if="this.funcionario.sueldo != null">
            <strong>Sueldo:</strong> {{ this.funcionario.sueldo }}
          </v-flex>
        </v-layout>

        <v-layout wrap row>
          <v-flex md4>
            <v-text-field
              type="date"
              label="Fecha desde"
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              @input="esFeriadoOFinDeSemana(form.fecha_desde, 1)"
              @change="alertarAprobacion()"
            />
          </v-flex>
          <v-flex md4>
            <v-text-field
              type="date"
              label="Fecha de conclusión"
              v-model="form.fecha_hasta"
              @input="esFeriadoOFinDeSemana(form.fecha_hasta, 2)"
              :rules="$validate(['required'])"
              required
            />
          </v-flex>
          <v-flex
            md4
            v-if="this.form.id_estado != 1 && this.form.id_estado != 53"
          >
            <v-autocomplete
              :items="unidades"
              item-text="nombre_unidad"
              :item-value="(val) => parseInt(val.id)"
              label="Lugar comisión"
              v-model="form.id_unidad"
              :rules="$validate(['required'])"
              required
              :disabled="form.editar"
              @change="obtenerOrganigrama"
            >
              <template v-slot:item="data">
                <v-tooltip left class="tree--rounded">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      {{ data.item.nombre_unidad }}
                    </div>
                  </template>
                  <v-treeview
                    class="white--text pa-1"
                    v-model="tree"
                    :open="[1, 2]"
                    :items="data.item.organigrama"
                    item-key="id"
                  >
                    <template v-slot:prepend="{ item }">
                      <v-icon class="white--text">
                        {{ item.icon }}
                      </v-icon>
                    </template>
                  </v-treeview>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios</small
      >
      <v-spacer></v-spacer>
      <v-btn @click.native="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :loading="loading"
        :disabled="!valid"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: [
    "id_tipo_justificacion",
    "funcionario",
    "unidades",
    "cargos",
    "puestos",
    "data",
  ],
  data() {
    return {
      valid: false,
      loading: false,
      form: this.data,
      treeOrganizacion: [],
      obtenerOrganigrama: [],
      tree: [],
      fecha_futuro: false,
      bandera_fecha: false,
      bandera_fecha2: false,
    };
  },
  mounted() {
    this.fijarDatosFuncionario();
  },
  methods: {
    alertarAprobacion() {
      if (this.form.id_estado == 64) {
        if (
          this.$moment() >= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono la fecha actual o una fecha pasada, por lo tanto la movilidad se aprobara si la guarda"
          );
        }
      }
      if (this.form.id_estado == 1 || this.form.id_estado == 53) {
        if (
          this.$moment() <= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono una fecha a futuro, por lo cual no puede guardar la movilidad, ya que fue aprobada"
          );
          this.fecha_futuro = true;
        } else {
          this.fecha_futuro = false;
        }
      }
    },
    async esFeriadoOFinDeSemana(fecha,valor){},
    async esFeriadoOFinDeSemanaVerificar(fecha, valor) {

      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        } else {
          this.bandera_fecha2 = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ", fecha);
          this.bandera_fecha = true;
          return true;
        }
        if (!fecha && valor == 2) {
          this.$message.info("Sin fecha hasta");
          this.bandera_fecha2 = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `,
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(
                `La fecha ${this.$moment(fecha).format(
                  "DD/MM/YYYY"
                )} cae en fin de semana o feriado`
              );
              this.bandera_fecha = true;
              return true;
            }
            if (respuesta == 1 && valor == 2) {
              this.$message.info(
                `La fecha ${this.$moment(fecha).format(
                  "DD/MM/YYYY"
                )} cae en fin de semana o feriado`
              );
              this.bandera_fecha2 = true;
              return true;
            }
            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
        this.form.fecha_desde,
        1
      );
      let validacion_fecha2 = await this.esFeriadoOFinDeSemanaVerificar(
        this.form.fecha_hasta,
        1
      );
      if (validacion_fecha || validacion_fecha2) {
        return;
      }
      // await this.esFeriadoOFinDeSemana(this.form.fecha_desde,1);
      // await this.esFeriadoOFinDeSemana(this.form.fecha_hasta,2);
      // if (this.bandera_fecha || this.bandera_fecha2) {
      //   return;
      // }
      if (this.form.editar) {
        try {
          if (this.$refs.form.validate()) {
            this.loading = true;
            let id_puesto = this.form.id_puesto;
            let id_cargo = this.form.id_cargo;
            let id_tipo_justificacion = this.id_tipo_justificacion;

            let user = this.$storage.get("user");
            console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.funcionario.item}, ${id_tipo_justificacion},'${this.form.fecha_hasta}',${this.form.id_estado})"){
                    respuesta
                  }
                }
              `);
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.funcionario.item}, ${id_tipo_justificacion},'${this.form.fecha_hasta}',${this.form.id_estado})"){
                    respuesta
                  }
                }
              `,
            });
            res =
              res.runQuery.respuesta[0].fn_modifica_movilidad_interinato_estado;

            let resps = res.split("|");
            let correcto = resps[0];
            console.log(correcto);

            if (correcto === "1") {
              this.$message.success("Registro exitoso");
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          if (this.$refs.form.validate()) {
            let item_puesto_cargo = [];
            item_puesto_cargo = await this.obtenerIdPuestoCargoItem(
              parseInt(this.funcionario.id_persona)
            );
            let id_puesto = item_puesto_cargo[1];
            let id_cargo = item_puesto_cargo[2];
            this.funcionario.nro_item = item_puesto_cargo[0];

            let id_tipo_justificacion = this.id_tipo_justificacion;

            let user = this.$storage.get("user");
            console.log(`
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_temporal(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.funcionario.nro_item}, ${id_tipo_justificacion},'${this.form.fecha_hasta}')"){
                    respuesta
                  }
                }
              `);
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_alta_movilidad_temporal(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.funcionario.nro_item}, ${id_tipo_justificacion},'${this.form.fecha_hasta}')"){
                    respuesta
                  }
                }
              `,
            });

            res = res.runQuery.respuesta[0].fn_alta_movilidad_temporal;

            let resps = res.split("|");
            let correcto = resps[0];
            //console.log(correcto);

            if (correcto === "1") {
              this.$message.success();
              //this.$router.push('/personas')
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async obtenerIdPuestoCargoItem(id_persona) {
      try {
        let nro_item = 0;
        let id_cargo = 0;
        let id_puesto = 0;
        let item_cargo_puesto = [0, 0, 0];
        let res = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_datos_de_persona(${id_persona})"){
                    respuesta
                  }
                }
              `,
        });
        if (
          res.runQuery.respuesta[0].fn_datos_de_persona ||
          res.runQuery.respuesta[0].fn_datos_de_persona != null
        ) {
          res = res.runQuery.respuesta[0].fn_datos_de_persona;
          let rpta = res.split("|");
          if (rpta[0] == "1") {
            // nro_item = rpta[2];//nro item-cadena
            // id_cargo = rpta[3];
            // id_puesto = rpta[4];
            item_cargo_puesto[0] = rpta[2];
            item_cargo_puesto[1] = rpta[4];
            item_cargo_puesto[2] = rpta[3];
          }
        }
        return item_cargo_puesto;
        // if (valor == 1) {
        //   console.log(valor,("//////"),)
        //   return nro_item;
        // }
        // if (valor == 2) {
        //   console.log(valor,("//////"),)
        //   return id_cargo;
        // }
        // if (valor == 3) {
        //   console.log(valor,("//////"),)
        //   return id_puesto;
        // }
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearMovilidad");
    },
    fijarDatosFuncionario() {
      if (this.id_tipo_justificacion === 2) {
        this.form.id_unidad = this.form.id_unidad;
        this.form.padres_unidad = this.form.padres_unidad;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/ComisionServicio.vue